if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.setupMobileCarousel();
      }

      setupMobileCarousel() {
        if (this.dataset.gpMobileCarouselReady) {
          this.updateMobileCounter();
          return;
        }
        this.dataset.gpMobileCarouselReady = 'true';

        this.querySelector('[data-gp-modal-prev]')?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.stepMobileMedia(-1);
        });
        this.querySelector('[data-gp-modal-next]')?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.stepMobileMedia(1);
        });

        const content = this.querySelector('.product-media-modal__content');
        let startX = 0;
        let startY = 0;
        content?.addEventListener('touchstart', (event) => {
          const touch = event.changedTouches[0];
          startX = touch.clientX;
          startY = touch.clientY;
        }, { passive: true });
        content?.addEventListener('touchend', (event) => {
          const touch = event.changedTouches[0];
          const distanceX = touch.clientX - startX;
          const distanceY = touch.clientY - startY;
          if (Math.abs(distanceX) > 45 && Math.abs(distanceX) > Math.abs(distanceY)) {
            this.stepMobileMedia(distanceX < 0 ? 1 : -1);
          }
        }, { passive: true });
        this.updateMobileCounter();
      }

      getMobileMedia() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      stepMobileMedia(direction) {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        const media = this.getMobileMedia();
        if (media.length < 2) return;
        let current = media.findIndex((item) => item.classList.contains('active'));
        if (current < 0) current = 0;
        const next = (current + direction + media.length) % media.length;
        media.forEach((item, index) => item.classList.toggle('active', index === next));
        const image = media[next].querySelector('img') || (media[next].matches('img') ? media[next] : null);
        if (image) image.loading = 'eager';
        this.updateMobileCounter(next, media.length);
      }

      updateMobileCounter(index, total) {
        const media = this.getMobileMedia();
        const currentIndex = index ?? Math.max(0, media.findIndex((item) => item.classList.contains('active')));
        const totalCount = total ?? media.length;
        const currentElement = this.querySelector('[data-gp-modal-current]');
        const totalElement = this.querySelector('[data-gp-modal-total]');
        if (currentElement) currentElement.textContent = String(currentIndex + 1);
        if (totalElement) totalElement.textContent = String(totalCount);
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
        this.updateMobileCounter();
      }
    }
  );
}
